module.exports = __webpack_public_path__ + "static/media/blog_12.4d8ab0d4.jpg";